/*
 *   File : icon.js
 *   Author : https://evoqins.com
 *   Description : Icon component
 *   Integrations : icomoon-react
 *   Version : 1.0.0
*/

// custom packages
import { memo } from "react";

import IcomoonReact from "icomoon-react";
const iconSet = require("../../Assets/Fonts/selection.json");

const Icon = ({ onClick, ...props }) =>
    <div className={props.wrapperClass} onClick={onClick}>
        <IcomoonReact iconSet={iconSet} {...props} />
    </div>

export default memo(Icon);